import { Module } from "vuex";
import { IXtrtState, initialState } from "./state";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { getters } from "./getters";

const xtrt: Module<IXtrtState, any> = {
    namespaced: true,
    state: initialState,
    getters,
    mutations,
    actions,
};

export { xtrt };
